import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent, Typography, Box } from "@material-ui/core";
import ButtonSmg from "../ButtonSmg";
import { useStyles } from "../../hooks";
import styles from "./styles";

export const EMERGENCY_PHONE_DISPLAY = "0810-333-3226";
export const EMERGENCY_PHONE_TEL = "08103333226";

/**
 * Modal Figma (menu-mobile / Menú=modal): confirmación antes de llamar a emergencias.
 */
const EmergencyCallDialog = ({
  open,
  onClose,
  phoneDisplay = EMERGENCY_PHONE_DISPLAY,
  phoneTel = EMERGENCY_PHONE_TEL,
}) => {
  const classes = useStyles(styles);

  const handleCall = useCallback(() => {
    window.location.href = `tel:${phoneTel}`;
    if (onClose) onClose();
  }, [onClose, phoneTel]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="emergency-call-title"
      aria-describedby="emergency-call-desc"
      BackdropProps={{ className: classes.backdrop }}
      PaperProps={{ className: classes.paper, elevation: 0 }}
    >
      <DialogContent className={classes.content}>
        <Box className={classes.textBlock}>
          <Typography
            id="emergency-call-title"
            component="h2"
            className={classes.title}
          >
            Emergencias y urgencias
          </Typography>
          <Typography id="emergency-call-desc" className={classes.body}>
            Content
          </Typography>
        </Box>

        <Box className={classes.actions}>
          <ButtonSmg
            id="btn-emergency-call"
            theme="material"
            color="primary"
            content="Llamar"
            buttonRoot={false}
            className={classes.primaryBtn}
            onClick={handleCall}
          />
          <ButtonSmg
            id="btn-emergency-cancel"
            theme="material"
            color="default"
            variant="contained"
            content="Cancelar"
            buttonRoot={false}
            className={classes.secondaryBtn}
            onClick={onClose}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

EmergencyCallDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  phoneDisplay: PropTypes.string,
  phoneTel: PropTypes.string,
};

export default EmergencyCallDialog;
